<template>
  <div class="contact-us-component">
    <div class="section-2">
      <el-row>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
          <div class="new-feedback-card" v-loading="isLoading">
            <div class="left-card">
              <h1>
                Contact <br />
                Information
              </h1>
              <div class="inner-sec">
                <div>
                  <img
                    src="../../assets/images/RetailSideLandingPurple/email.png"
                    alt=""
                  />
                </div>
                <div>
                  <p>admin@stockants.com</p>
                  <p>partner@stockants.com</p>
                </div>
              </div>
              <div class="inner-sec">
                <div>
                  <img
                    src="../../assets/images/phone.png"
                    alt=""
                  />
                </div>
                <div>
                  <p>+91 9321765323</p>
                </div>
              </div>
              <div class="inner-sec">
                <div>
                  <img
                    src="../../assets/images/RetailSideLandingPurple/location.png"
                    alt=""
                  />
                </div>
                <div>
                  <p>
                    STOCKANTS <br />
                    407, Runwal Square
                    Lal Bahadur Shastri Rd,
                    next to Runwal Anthurium,
                    Mulund West, Mumbai, Maharashtra 400080, India
                  </p>
                </div>
              </div>

              <h3 style="font-weight: 600">Follow Us</h3>

              <div class="social-icon-container">
                <a :href="twitter_link" target="_blank">
                  <img
                    class="social-icon"
                    src="../../assets/images/RetailSideLandingPurple/twitter 1.png"
                    alt
                  />
                </a>
                <a :href="fb_link" target="_blank">
                  <img
                    class="social-icon"
                    src="../../assets/images/facebook.png"
                    alt
                  />
                </a>
                <a :href="linkedIn_link" target="_blank">
                  <img
                    class="social-icon"
                    src="../../assets/images/linkedin.png"
                    alt
                  />
                </a>
              </div>
            </div>
            <div class="right-card">
              <el-row>
                <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4"
                  >&nbsp;</el-col
                >
                <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                  <el-card>
                    <div>
                      <h1>Get In Touch</h1>
                      <p class="below-txt">Leave us a Message below!</p>

                      <div class="label">
                        Name <span style="color: red">*</span>
                      </div>
                      <div class="input-group-section">
                        <div
                          class="form-group"
                          :class="{
                            'not-empty': name.length,
                            'form-group--error':
                              show_error_on_empty && $v.name.$error,
                          }"
                        >
                          <el-input
                            v-model="name"
                            size="small"
                            type="text"
                            class="form-control"
                            placeholder="Name"
                            name="Name"
                            @input="setName($event)"
                          ></el-input>
                        </div>
                        <div
                          class="error"
                          v-if="show_error_on_empty && !$v.name.required"
                        >
                          Field is required
                        </div>
                      </div>

                      <div class="label">
                        Email <span style="color: red">*</span>
                      </div>
                      <div class="input-group-section">
                        <div
                          class="form-group"
                          :class="{
                            'not-empty': email.length,
                            'form-group--error':
                              show_error_on_empty && $v.email.$error,
                          }"
                        >
                          <el-input
                            type="email"
                            v-model="email"
                            size="small"
                            class="form-control"
                            placeholder="Email"
                            name="email"
                            @input="setEmail($event)"
                          ></el-input>
                        </div>
                        <div class="error-text" v-if="is_valid_email_error">
                          Use valid email address
                        </div>
                        <div
                          class="error"
                          v-if="show_error_on_empty && !$v.email.required"
                        >
                          Field is required
                        </div>
                      </div>

                      <div class="label">
                        Phone<span style="color: red">*</span>
                      </div>
                      <div class="phone-input">
                        <div class="input-group-section">
                          <div
                            class="form-group"
                            :class="{
                              'not-empty': phone.length,
                              'form-group--error':
                                show_error_on_empty && $v.phone.$error,
                            }"
                          >
                            <el-input
                              v-model="phone"
                              size="small"
                              type="number"
                              class="form-control"
                              placeholder="Phone"
                              name="Phone"
                              @input="setPhoneNo($event)"
                            >
                              <template slot="prepend">+91</template>
                            </el-input>
                          </div>
                          <div class="error-text" v-if="!isPhoneNoValid">
                            Please enter a valid phone number
                          </div>
                          <div
                            class="error"
                            v-if="show_error_on_empty && !$v.phone.required"
                          >
                            Field is required
                          </div>
                        </div>
                      </div>

                      <div class="label">
                        Comment<span style="color: red">*</span>
                      </div>
                      <div class="input-group-section">
                        <div
                          class="form-group"
                          :class="{
                            'not-empty': comment.length,
                            'form-group--error':
                              show_error_on_empty && $v.comment.$error,
                          }"
                        >
                          <el-input
                            type="textarea"
                            :autosize="{ minRows: 10, maxRows: 14 }"
                            placeholder="Write here"
                            v-model="comment"
                            @input="setComment($event)"
                          >
                          </el-input>
                        </div>
                        <div
                          class="error"
                          v-if="show_error_on_empty && !$v.comment.required"
                        >
                          Field is required
                        </div>
                      </div>

                      <div class="text-right">
                        <button class="send-btn" @click="contactUs()">
                          SEND
                        </button>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :xs="2" :sm="3" :md="3" :lg="3" :xl="3">&nbsp;</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "../../networkConfig";
import { required } from "vuelidate/lib/validators";
import CripNotice from "crip-vue-notice";

export default {
  name: "ContactUsComponent",

  components: {},

  mixins: [],

  data() {
    return {
      twitter_link: "https://twitter.com/StockAnts",
      fb_link:
        "https://www.facebook.com/StockAnts/?view_public_for=186471548792050",
      linkedIn_link:
        "https://www.linkedin.com/company/stockants/about/?viewAsMember=true",
      name: "",
      email: "",
      phone: "",
      comment: "",
      show_error_on_empty: false,
      is_valid_email_error: false,
      isPhoneNoValid: true,
      isLoading: false,
    };
  },
  watch: {
    email(newValue, oldValue) {
      let regularExpression =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (newValue.trim()) {
        this.is_valid_email_error = false;

        if (regularExpression.test(newValue)) {
          this.is_valid_email_error = false;
        } else {
          this.is_valid_email_error = true;
          // this.is_valid_email_error = true;
        }
      } else {
        // this.is_valid_email_error = false;
      }
    },
  },
  validations: {
    name: {
      required,
    },
    email: {
      required,
    },
    phone: {
      required,
    },
    comment: {
      required,
    },
  },

  methods: {
    setName(value) {
      this.name = value;
      this.$v.name.$touch();
    },
    setEmail(value) {
      this.email = value;
      this.$v.email.$touch();
    },
    setPhoneNo(value) {
      this.phone = value;
      this.$v.phone.$touch();
      this.isPhoneNoValid = true;
    },
    setComment(value) {
      this.comment = value;
      this.$v.comment.$touch();
    },
    contactUs() {
      this.show_error_on_empty = true;
      this.$v.$touch();
      if (
        this.name.trim() &&
        this.email &&
        !this.is_valid_email_error &&
        this.phone.toString().length == 10 &&
        this.comment.trim()
      ) {
        this.isLoading = true;
        serverAddr
          .post(`/base/v1/contact_us`, {
            name: this.name,
            email: this.email,
            phone: this.phone,
            message: this.comment,
          })
          .then((response) => {
            this.isLoading = false;
            if (response.data.status) {
              new CripNotice({
                title: "Success",
                description: response.data.validation,
                type: "success",
                duration: 3,
              });
            }
          })
          .catch((error) => {
            this.isLoading = false;
            console.log("error", error);
            new CripNotice({
              title: "Oops! Something went wrong!",
              description: "Please try again",
              type: "error",
              duration: 3,
            });
          });
      } else if (this.phone.toString().length != 10) {
        this.isPhoneNoValid = false;
      }
    },
  },
  mounted() {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.contact-us-component {
  .section-2 {
    .new-feedback-card {
      .left-card {
        width: 320px;
        background: #ffda6f;
        border: 1px solid #ffda6f;
        border-radius: 20px;
        padding: 20px 40px;
        position: absolute;
        top: 10%;
        z-index: 1;
        .inner-sec {
          display: flex;
          margin-bottom: 40px;
        }
        h1 {
          font-weight: 600;
          text-transform: uppercase;
          text-align: center;
          font-size: 1.5rem;
          margin-bottom: 40px;
        }
        p {
          margin-top: 0;
        }

        img {
          margin-right: 30px;
          width: 27px;
        }
        .social-icon-container {
          display: flex;
          justify-content: center;
          margin-bottom: 30px;
          .social-icon {
            width: 40px;
            margin: 0 8px;
            cursor: pointer;
            transition: transform 0.2s; /* Animation */
          }
          .social-icon:hover {
            transform: scale(1.1);
          }
        }
      }
      .right-card {
        // height: 1000px;
        margin-bottom: 40px;
        h1 {
          color: #977b15;
          font-size: 1.8rem;
          text-transform: uppercase;
          margin-bottom: 0px;
        }
        .below-txt {
          margin-top: 0px;
          font-size: 0.9rem;
          font-weight: 500;
        }
        .label {
          text-transform: uppercase;
          color: #979797;
          font-size: 0.95rem;
          margin-bottom: 10px;
          margin-top: 30px;
        }
        .send-btn {
          font-size: 16px;
          font-weight: 700;
          padding: 10px 25px;
          border-radius: 10px;
          border: 1px solid #f9da7f;
          background-color: #f9da7f;
          margin: 30px 0;
          width: 200px;
          cursor: pointer;
        }
      }
    }
  }

  @media screen and (max-width: 1106px) {
    .section-2 .new-feedback-card .left-card {
      width: 280px;
    }
  }
  @media screen and (max-width: 992px) {
    .section-2 .new-feedback-card .left-card {
      position: unset;
      margin: 70px auto;
      width: 400px;
    }
  }

  @media screen and (max-width: 600px) {
    .section-2 {
      .new-feedback-card .left-card {
        width: 85%;
        padding: 20px;
      }
    }
  }
  @media screen and (max-width: 450px) {
    .section-2 {
      .new-feedback-card {
        .right-card,
        .left-card {
          p {
            font-size: 0.8rem;
          }
          h1 {
            font-size: 1.2rem;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" >
.contact-us-component {
  .section-2 {
    .right-card {
      .el-card {
        border-radius: 20px;
        box-shadow: 0 2px 20px 1px #ffda6f;
        border: 1px solid #f9e29f;
        padding-left: 27%;
        padding-right: 7%;
        padding-top: 10%;
        padding-bottom: 10%;
      }
      // .el-input {
      //   margin-bottom: 30px;
      // }
      .el-input-group__prepend {
        background-color: #f1f1f1;
      }
      .el-input-group__append,
      .el-input-group__prepend {
        border: 2px solid #f9e29f;
        border-right: 0;
      }
      .el-textarea__inner,
      .el-input__inner {
        border: 2px solid #f9e29f;
      }
      .phone-input {
        .el-input__inner {
          border-left: 0;
        }
      }
      @media screen and (max-width: 1244px) {
        .el-card {
          padding-left: 35%;
        }
      }

      @media screen and (max-width: 992px) {
        .el-card {
          padding: 50px;
        }
      }
      @media screen and (max-width: 768px) {
        .el-card {
          padding: 10px;
        }
      }
      @media screen and (max-width: 400px) {
        .el-card {
          padding: 0px;
        }
      }
    }
  }
}
</style>
